import { useIdentity } from '@interhyp/platform-auth';
import { MenuItem } from '@interhyp/platform-navigation';
import { matchPath, useLocation } from '@interhyp/platform-router';
import React from 'react';

import { COMPANY_ID_INTERHYP } from '../../constants/companies';

export function IntentToggle(): React.ReactElement {
  const identity = useIdentity();

  const { pathname } = useLocation();

  if (identity?.companyId !== COMPANY_ID_INTERHYP) {
    return <></>;
  }

  return (
    <MenuItem
      label="Meine Anträge"
      active={
        !!matchPath(pathname, {
          exact: true,
          path: '/',
        }) ||
        !!matchPath(pathname, {
          exact: false,
          path: '/mortgages/*',
        })
      }
      to="/"
    />
  );
}
